import type { LoaderFunctionArgs, MetaFunction } from "@remix-run/node";
import { json } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import type { SitemapFunction } from "remix-sitemap";

import { Accordion } from "~/components/Accordion";
import { getStringWithStaticDataLinks, StaticDataParser } from "~/components/static-data-parser";
import { faqData } from "~/config/faq";
import { getSeoMeta } from "~/utils/seo";

export const sitemap: SitemapFunction = () => {
  return faqData.map((item) => ({
    loc: `/faq/${item.categorySlug}`,
  }));
};

export const meta: MetaFunction<typeof loader> = (metaArgs) => {
  const categoryData = metaArgs.data?.categoryData;
  return getSeoMeta(metaArgs, {
    title: `FAQ - Questions de la catégorie : ${categoryData?.categoryLabel}`,
    description: `Consultez les réponses aux questions les plus fréquemment posées de la catégorie : ${categoryData?.categoryLabel}`,
    structuredData: {
      "@type": "FAQPage",
      mainEntity: categoryData?.questions.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: getStringWithStaticDataLinks(item.answer),
        },
      })),
    },
  });
};

export const loader = async ({ params }: LoaderFunctionArgs) => {
  const categorySlug = params.categorySlug || "frequentes";
  const categoryData = faqData.find((item) => item.categorySlug === categorySlug);
  return json({ categoryData });
};

const FAQCategoryPage = () => {
  const { categoryData } = useLoaderData<typeof loader>();

  return (
    <>
      <h2 className="mb-8 text-2xl font-medium text-grey-800">{categoryData?.categoryLabel}</h2>
      {categoryData?.questions.length && categoryData.questions.length > 0
        ? categoryData.questions.map((question) => (
            <Accordion title={question.question} key={question.question} className="mb-12">
              <p className="whitespace-pre-wrap leading-normal">
                <StaticDataParser string={question.answer} />
              </p>
            </Accordion>
          ))
        : null}
    </>
  );
};

export default FAQCategoryPage;
